// extracted by mini-css-extract-plugin
module.exports = {"businessPlatform":"businessPlatform_businessPlatform__1wJhC","buttonContainer":"businessPlatform_buttonContainer__2SZa0","homeText":"businessPlatform_homeText__3RFcl"};